import styled from 'styled-components';

export const Container = styled.div`
position:fixed;
overflow-y: scroll;
width: 100%;
height:100vh;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
background: rgba(0, 0, 0, 0.4);
z-index:120;
`;

export const SuccessContainer = styled.div`
width:280px;
height:303px;
background: #FFFFFF;
box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
border-radius: 12px;
z-index:250;
display:flex;
flex-direction:column;
align-items:center;
justify-content:flex-start;
`;

export const Img = styled.img`
margin-top:8px;
width: 130px;
height: 130px;
`;

export const Text = styled.span`
margin-top:22.3px;
font-family: Nunito;
font-style: normal;
font-weight: 700;
font-size: 14px;
line-height: 140%;
`;

export const Details= styled(Text)`
margin-top:8px;
font-style: normal;
font-weight: 400;
font-size: 12px;
display:flex;
flex-direction:column;
align-items:center;
`;

export const OkayBtn = styled.button`
margin-top:24px;
width:100px;
height:40px;
background: #454ADE;
box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05);
border-radius: 4px;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 14px;
line-height: 20px;
color: #FFFFFF;
border:none;
outline:none;
`;